import { render, staticRenderFns } from "./DocsHeader.vue?vue&type=template&id=7cac1d78&scoped=true&"
import script from "./DocsHeader.vue?vue&type=script&lang=js&"
export * from "./DocsHeader.vue?vue&type=script&lang=js&"
import style0 from "./DocsHeader.vue?vue&type=style&index=0&id=7cac1d78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cac1d78",
  null
  
)

export default component.exports